import { ResizeObserver as Polyfill } from '@juggle/resize-observer';
import { reaction, when } from "mobx";
import { useOnMount } from "./lifecycle.hooks";
var ResizeObserver = window.ResizeObserver || Polyfill;
export var useResizeObserver = function (handler, ref) {
    var observer = new ResizeObserver(handler);
    useOnMount(function () {
        var disposers = [];
        disposers.push(when(function () { return Boolean(ref === null || ref === void 0 ? void 0 : ref.current); }, function () {
            observer.observe(ref.current);
            disposers.push(reaction(function () { return !Boolean(ref === null || ref === void 0 ? void 0 : ref.current); }, function () {
                // console.log('unobserving', ref.current);
                ref.current && observer.unobserve(ref.current);
            }));
        }));
        return function () { return disposers.forEach(function (d) { return d(); }); };
    });
};
